<template>
  <form class="v-form" action="" method="post" v-on:submit.prevent="submitPrevented">
    <v-form-field v-for="field in fields" v-bind:key="field.name" :field-data="field" :form-data="formData" :form-errors="formErrors" :on-change="onChange" :on-blur="onBlur"></v-form-field>
    <slot name="buttons"></slot>
    <p v-if="formErrors.warrantyRegisterationDone" class="form__error-message first">{{loc('forms.messages.warrantyRegisterationNotDone')}}</p>
    <p v-if="Object.keys(formErrors).length > 0 && !formErrors.fieldError" class="form__error-message first">{{loc('forms.messages.hasErrors')}}</p>
  </form>
</template>

<script>
import VFormField from './v-form-field.vue';

export default {
  components: {
    'v-form-field': VFormField
  },
  props: ['fields', 'form-data', 'form-errors', 'on-change', 'on-blur'],
  methods: {
    // Prevent default submits
    submitPrevented() {
    }
  }
}
</script>

<style>

</style>
